<template>
	<div class="rechargeManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">充值管理</div>
		</div>
		<div class="mainBot ">
			<div class="contentTop" v-if="mainUser==1">
				<statisticalAnalysis></statisticalAnalysis>
			</div>
			<div class="contentBot" :class="{mainBox:mainUser!=1}">
				<chargingRecord ></chargingRecord>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import chargingRecord from "./chargingRecord/chargingRecord.vue"
	import statisticalAnalysis from "./statisticalAnalysis/statisticalAnalysis.vue"
	export default {
		name: "rechargeManage",
		components: {
			chargingRecord,
			statisticalAnalysis
		},
		data() {
			return {
				mainUser:0
			}
		},
		mounted() {
			this.mainUser=localStorage.getItem('mainUser')||0
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			getData() {},

		}
	}
</script>

<style lang="scss" scoped>
	@import "./rechargeManage.scss";
</style>
